import React from 'react';
import { SkeletonBlock } from '@one-thd/sui-atomic-components';

export function TileItemsPlaceholder() {
  const imagePlaceholder = [...Array(4)].map((key, index) => (
    <React.Fragment key={`tileItemsImagePlaceholder${index}`}>
      <span className="sui-mr-3">
        <SkeletonBlock aspect="wide" height={16} width={16} />
      </span>
    </React.Fragment>
  ));

  return <div className="sui-flex">{imagePlaceholder}</div>;
}
